import React from 'react';

const TransformBox = ({
  bounds,
  handles,
  onHandlePointerDown,
  onRotatePointerDown,
}) => {
  if (!bounds) return null;
  const { x, y, width, height } = bounds;
  const handleList = handles && handles.length
    ? handles
    : ['nw', 'n', 'ne', 'e', 'se', 's', 'sw', 'w'];
  return (
    <div
      className="studio-transform-box"
      style={{
        left: x,
        top: y,
        width,
        height,
      }}
    >
      <div className="studio-transform-outline" />
      {handleList.map((handle) => (
        <button
          key={handle}
          type="button"
          className={`studio-transform-handle ${handle}`}
          onPointerDown={(event) => {
            event.preventDefault();
            event.stopPropagation();
            onHandlePointerDown(event, handle);
          }}
          aria-label={`Resize ${handle}`}
        />
      ))}
      <button
        type="button"
        className="studio-rotate-handle"
        onPointerDown={(event) => {
          event.preventDefault();
          event.stopPropagation();
          onRotatePointerDown(event);
        }}
        aria-label="Rotate"
      />
      <div className="studio-rotate-connector" />
    </div>
  );
};

export default TransformBox;
